"use strict";function t(r,e){return process.env.NODE_ENV==="production"?()=>null:function(...n){return r(...n)||e(...n)}}exports.chainPropTypes=t;
